import { render, staticRenderFns } from "./SubscriptionPlanOverview.vue?vue&type=template&id=db37bae8&scoped=true&"
import script from "./SubscriptionPlanOverview.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionPlanOverview.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionPlanOverview.vue?vue&type=style&index=0&id=db37bae8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db37bae8",
  null
  
)

export default component.exports